import { render, staticRenderFns } from "./PatientFilters.vue?vue&type=template&id=f11f3ce6&scoped=true"
import script from "./PatientFilters.vue?vue&type=script&lang=js"
export * from "./PatientFilters.vue?vue&type=script&lang=js"
import style0 from "./PatientFilters.vue?vue&type=style&index=0&id=f11f3ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11f3ce6",
  null
  
)

export default component.exports